module.exports = __webpack_public_path__ + "img/company-config.75bb7f71.svg";